<h1 mat-dialog-title>{{"PAUSE_DIALOG.SURE" | translate}}</h1>
<div  class="btn-group">
  <button mat-button  (click)="stopWorkout()">{{"PAUSE_DIALOG.CANCEL" | translate}}</button>
  <button mat-button mat-dialog-close cdkFocusInitial (click)="close()">{{"PAUSE_DIALOG.CONTINUE" | translate}}</button>
</div>
